export const NB_CHAT_COMMON_FILTER = 'newbuilding_chat_common_filter';
export const NB_CONSULTANT_TRIGGERING_MESSAGE = 'newbuilding-triggering-message';
export const NB_HELP_IN_SEARCH = 'newbuilding_consultant_help_in_search';
export const RENTER_FORM_EXPERIMENT = 'renter_form_experiment';
export const PERSONAL_RANKING = 'aud_desktop_cd178510_ranking_v3';
export const WEB_3D_TOURS_EXPERIMENT = 'b2b_3d_tours_web';
export const AA_TEST_50 = 'aud_desktop_aud2904_split_50_listing_aa_expf';
export const AA_TEST_30 = 'aud_desktop_aud2904_split_30_listing_aa_expf';
export const NEWBUILDING_AA_TEST_50 = 'newbuiliding_test_for_expf_desktop_50_50';
export const NEWBUILDING_AA_TEST_30 = 'newbuiliding_test_for_expf_desktop_70_30';
export const WEB_TO_APP_BANNER = 'aud_desktop_aud2918_qr_banner_web_to_app';

export const EXPERIMENTS: string[] = [
  'newbuilding_consultant',
  NB_CHAT_COMMON_FILTER,
  NB_CONSULTANT_TRIGGERING_MESSAGE,
  NB_HELP_IN_SEARCH,
  RENTER_FORM_EXPERIMENT,
  PERSONAL_RANKING,
  WEB_3D_TOURS_EXPERIMENT,
  AA_TEST_50,
  AA_TEST_30,
  NEWBUILDING_AA_TEST_50,
  NEWBUILDING_AA_TEST_30,
  WEB_TO_APP_BANNER,
];
